
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaked-private-photos",
      function () {
        return require("private-next-pages/leaked-private-photos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaked-private-photos"])
      });
    }
  